import { ButtonElement } from '@typedream/core';
import { unsetNodes } from '@udecode/plate-core';
import { Path } from 'slate';
import { DreamEditor } from '../../../types';

export const removeButtonIcon = (editor: DreamEditor, at: Path) => {
  unsetNodes<ButtonElement>(editor, ['icon'], { at });
};
